import React, { useState } from "react";
import imageCompression from "browser-image-compression";
import {
  Box,
  Typography,
  Snackbar,
  Alert,
  Paper
} from "@mui/material";
import { NoSuggestionsTextField } from "../../../../components/textFields";
import { SendButton } from "../../../../components/buttons";
import CustomAutocomplete from "../../../../components/autoComplete";

function CreateImage({ name, setName, setImage, categories, categoryCreate, setCategoryCreate }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxFileSizeMB = 10;
    const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;

    if (file.size > maxFileSizeBytes) {
      showSnackbar(
        `La imagen no debe superar los ${maxFileSizeMB}MB. Tamaño actual: ${(file.size / 1024 / 1024).toFixed(2)}MB`
      );
      return;
    }

    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 800,
        useWebWorker: true,
      };

      const compressedFile = await imageCompression(file, options);
      setImage(compressedFile);

      const previewURL = URL.createObjectURL(compressedFile);
      setPreviewUrl(previewURL);
    } catch (error) {
      console.error("Error al comprimir la imagen:", error);
      showSnackbar("Error al comprimir la imagen");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <NoSuggestionsTextField
        autoFocus
        required
        margin="dense"
        id="name"
        label="Nombre de la Imagen"
        type="text"
        fullWidth
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      {/* Selector de categoría */}
      <CustomAutocomplete
        options={categories.map((c) => ({ id: c.id, label: c.title }))}
        value={categoryCreate}
        onChange={(e, newCategoryId) => setCategoryCreate(newCategoryId ?? "")}
        label="Categoría"
        required
        returnLabel
      />

      <Box sx={{ marginTop: "16px", display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>

        {/* Vista previa — aparece centrada ENCIMA del botón cuando hay imagen */}
        {previewUrl && (
          <Paper
            elevation={0}
            sx={{
              width: "100%",
              p: 2,
              borderRadius: "16px",
              backgroundColor: "#f9f9f9",
              textAlign: "center",
              border: "1px dashed #d1d5db",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="subtitle2" sx={{ color: "#444", fontWeight: 600 }}>
              Imagen seleccionada
            </Typography>
            <Box
              component="img"
              src={previewUrl}
              alt="Vista previa"
              sx={{
                maxWidth: "280px",
                width: "100%",
                height: "auto",
                maxHeight: "200px",
                borderRadius: "12px",
                objectFit: "contain",
                boxShadow: "0 4px 14px rgba(0, 0, 0, 0.1)",
              }}
            />
          </Paper>
        )}

        {/* Botón de carga centrado */}
        <input
          id="product_image"
          name="product_image"
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{ display: "none" }}
        />
        <label htmlFor="product_image" style={{ width: "100%" }}>
          <SendButton
            component="span"
            sx={{
              width: "100%",
              padding: "12px",
            }}
          >
            {previewUrl ? "Cambiar imagen" : "Subir Imagen"}
          </SendButton>
        </label>
        <Typography
          variant="caption"
          sx={{ color: "#6b6b6b", textAlign: "center" }}
        >
          Seleccione una imagen (PNG, JPG, JPEG)
        </Typography>
      </Box>

      {/* Snackbar para errores */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default CreateImage;